import { render } from "./MealPreparationGroups.vue?vue&type=template&id=01bce13e"
import script from "./MealPreparationGroups.vue?vue&type=script&lang=js"
export * from "./MealPreparationGroups.vue?vue&type=script&lang=js"

import "./MealPreparationGroups.vue?vue&type=style&index=0&id=01bce13e&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__